<template>
  <div id="app">
    <router-view/>
    <FloatingTools />
  </div>
</template>

<script>
  import FloatingTools from '@/components/floating-tools'

  export default {
    name: 'App',
    components: {
      FloatingTools
    }
  }
</script>

<style lang="less">
  @import "./global.less";
</style>

